import React, { Component } from 'react'
import { DeletePopup } from '../../../../Components/Common Components/CommonComponents'
import { withTranslation } from 'react-i18next';
import { DataGrid } from '@mui/x-data-grid';
import { Box, Button,  Stack, Tooltip, Typography, TextField } from '@mui/material';
import RestAPIService from '../../../../Utility/Services/RestAPIService';
import { Serviceurls } from '../../../../Utility/API/Serviceurls';
import ToastMsg from '../../../../Components/ToastMsg/ToastMsg';
  import ShowComponents from '../Common/ShowComponent';
import { ImagePaths } from '../../../../Utility/ImagePaths';
import DescriptionIcon from '@mui/icons-material/Description';
import { localGetItem } from "../../../../Utility/Services/CacheProviderService";

let showComplaints = false;
class OtherDocComplaintsLeft extends Component {
    constructor(props) {
        super(props)
        this.state = {
            complainsData: [],
            isDeleteCliked: false,
            SelectedList: {},
            PatientData: this.props?.PatientData,
            EditItem: {},
            updateId: "",
            isEdit: false,
            commonCommentsTxt: ""
        }
    }

    componentDidUpdate(prevprops) {
        showComplaints = JSON.parse(localGetItem("complaints_common_textbox"));
        if (prevprops.GetAPiCall !== this.props.GetAPiCall && this.props.GetAPiCall) { this.getComplaintsData() }
        if (prevprops.SelectedComponent !== this.props.SelectedComponent && this.props.SelectedComponent) {
            this.setState({ EditItem: {} })
        }
    }

    errorMessage = (message) => {
        this.setState({
            isErrorMsg: true,
            isErrorMsgText: message
        })
    }

    successMessage = (message) => {
        this.setState({
            successMsg: true,
            successMsgText: message
        })
    }

    generateCommonComments = (items) => {
        let result = "";
        for (let i = 0; i < items.length; i++) {
            if (items[i].comments) {
                result += `${i + 1}. ${items[i].comments}\n`;
            }
        }
        console.log(result, "from the function")
        return result.trim();
    };

    getComplaintsData = () => {
        try {
            this.setState({ loading: true })
            RestAPIService.getAll(Serviceurls.DOC_DOCTOR_NOTES_COMPLAINTS_GET + `?appointment_id=${this.props.PatientData.appointment_id}`)
                .then((response) => {
                    if (response?.data?.status === 'success') {
                        let txt = ""
                        if(showComplaints){
                            txt = this.generateCommonComments(response?.data?.data)
                        }
                        this.setState({
                            complainsData: response?.data?.data ? response?.data?.data : [],
                            loading: false,
                            isEdit: false,
                            commonCommentsTxt : txt,
                        })
                    }
                }).catch((error) => {
                    if (error?.response?.data?.message) {
                        this.setState({ loading: false })
                        this.errorMessage(error.response.data.message)
                    } else {
                        this.setState({ loading: false })
                        this.errorMessage(error.message)
                    }
                })
        } catch (error) {
            this.setState({ loading: false })
            this.errorMessage(error.message)
        }
    }


    onEditHandler(data) {
        this.setState({
            updateId: data?.id,
            EditItem: data,
            isEdit: true
        }, () => {
            this.props.EditComplaintData(this.state.EditItem)
        })
    }
    onDeleteHandler(data) {
        try {
            this.setState({
                isDeleteCliked: true,
                SelectedList: data,
                updateId: data?.id
            })
        } catch (error) {
            this.errorMessage(error.message)
        }
    }

    popupClose() {
        this.setState({ isDeleteCliked: false, SelectedList: {} })
    }
    DeleteComplaintsData = () => {
        try {
            let data = {}
            this.setState({ removeData: true })
            RestAPIService.delete(Serviceurls.DOC_DOCTOR_NOTES_COMPLAINTS_DELETE + `?id=${this.state.updateId}`, data)
                .then((response) => {
                    if (response?.data?.status === 'success') {
                        this.successMessage(response?.data?.message)
                        this.getComplaintsData()
                        this.setState({ isDeleteCliked: false, deletePopup: false, removeData: false, updateId: "" })
                    }
                }).catch((error) => {
                    if (error?.response?.data?.message) {
                        this.setState({ removeData: false })
                        this.errorMessage(error.response.data.message)
                    } else {
                        this.setState({ removeData: false })
                        this.errorMessage(error.message)
                    }
                })
        } catch (error) {
            this.setState({ removeData: false })
            this.errorMessage(error.message)
        }
    }
    msgClose() {
        this.setState({
            isErrorMsg: false,
            isErrorMsgText: '',
            successMsg: false,
            successMsgText: ''
        })
    }
    render() {
        const { t } = this.props
        this.state.complainsData?.forEach((element, index) => { element.sno = index + 1 })
        const columns = [
            {
                field: "complaint_description", flex: 0.333, headerName: t("Complaint"),
                renderCell: (params) => {
                    return (<Box component={'div'} emed_tid={`other_doc_complaints_left_complaint_cell_${params.row.sno}`}>
                        {params?.row?.complaint_description ? params?.row?.complaint_description?.length > 25 ?
                            <Tooltip placement='top' title={params?.row?.complaint_description} arrow emed_tid={`other_doc_complaints_left_complaint_tooltip_${params.row.sno}`}>
                                <div emed_tid={`other_doc_complaints_left_complaint_text_${params.row.sno}`}>{params?.row?.complaint_description.slice(0, 25) + "..."}</div></Tooltip> :
                            params?.row?.complaint_description : "-"}
                    </Box>)
                }
            },
            {
                field: "duration_type", flex: 0.333, headerName: t("Duration"), headerAlign: "center", align: 'center',
                renderCell: ({ row }) => {
                    return (<Box emed_tid={`other_doc_complaints_left_duration_cell_${row.sno}`}>
                        {row?.duration_time ?
                            row?.duration_time?.length > 10 ?
                                <Tooltip placement='top' title={row?.duration_time} emed_tid={`other_doc_complaints_left_duration_tooltip_${row.sno}`}>
                                    <Typography fontSize={'0.8vw'} fontWeight={600} mr={'0.5vw'} emed_tid={`other_doc_complaints_left_duration_text_${row.sno}`}>{row?.duration_time?.slice(0, 10) + '...'}</Typography>
                                </Tooltip> :
                                <Typography fontSize={'0.8vw'} fontWeight={600} mr={'0.5vw'} emed_tid={`other_doc_complaints_left_duration_text_${row.sno}`}>{row?.duration_time + " " + (row?.duration_type == 1 ? "Days" : row?.duration_type == 2 ? "Weeks" : row?.duration_type == 3 ? "Months" : "Years")}</Typography> : '-'
                        }
                    </Box>)
                }
            },
            {
                field: "action", flex: 0.333, headerName: t("Action"), headerAlign: "center", align: "center",
                renderCell: (params) => {
                    return (<Box display={"flex"} flexDirection={"row"} alignItems={"center"} emed_tid={`other_doc_complaints_left_action_cell_${params.row.sno}`}>
                        <Button className='Common_Btn_Min_Width'
                            disabled={this.state.isLocked || this.props.isLocked}
                            onClick={() => { this.onEditHandler(params.row) }}
                            emed_tid={`other_doc_complaints_left_edit_btn_${params.row.sno}`}
                        >
                            <Tooltip placement='top' title={'Edit'} emed_tid={`other_doc_complaints_left_edit_tooltip_${params.row.sno}`}>
                                {this.state.isLocked || this.props.isLocked ?
                                    <Box component={'img'} src={ImagePaths.DisabledEdit.default} height={'1.2vw'} width={'1.2vw'} emed_tid={`other_doc_complaints_left_edit_icon_disabled_${params.row.sno}`} />
                                    :
                                    <Box component={'img'} src={ImagePaths.UserEditOn.default} height={'1.2vw'} width={'1.2vw'} emed_tid={`other_doc_complaints_left_edit_icon_${params.row.sno}`} />
                                }
                            </Tooltip>
                        </Button>
                        <Button className='Common_Btn_Min_Width' disabled={this.state.isLocked || this.props.isLocked || this.state.isEdit}
                            onClick={() => this.onDeleteHandler(params.row)}
                            emed_tid={`other_doc_complaints_left_delete_btn_${params.row.sno}`}
                        >
                            {this.state.isLocked || this.props.isLocked || this.state.isEdit ?
                                <Box component={'img'} src={ImagePaths.DisabledDelete.default} height={'1.2vw'} width={'1.2vw'} emed_tid={`other_doc_complaints_left_delete_icon_disabled_${params.row.sno}`} />
                                :
                                <Box component={'img'} src={ImagePaths.DeleteOutline.default} height={'1.2vw'} width={'1.2vw'} emed_tid={`other_doc_complaints_left_delete_icon_${params.row.sno}`} />
                            }
                        </Button>
                        {!showComplaints && <Button emed_tid={`other_doc_complaints_left_comments_btn_${params.row.sno}`}>
                            {params.row?.comments ? <Tooltip placement='top' title={params.row.comments} emed_tid={`other_doc_complaints_left_comments_tooltip_${params.row.sno}`}><DescriptionIcon color='primary' emed_tid={`other_doc_complaints_left_comments_icon_${params.row.sno}`} /></Tooltip> : null}
                        </Button>}
                    </Box>)
                }
            }
        ]
        return (
            <ShowComponents onIntersection={this.getComplaintsData.bind(this)}>
                <Box height={'20vh'} overflow={'auto'} emed_tid="other_doc_complaints_left_container">
                    <DataGrid
                        emed_tid="other_doc_complaints_left_datagrid"
                        density='compact'
                        rows={this.state.complainsData}
                        columns={columns}
                        getRowId={(row) => row['sno']}
                        headerHeight={40}
                        hideFooter={true}
                        components={{
                            NoRowsOverlay: () => (
                                <Stack className='eMed_DocNotes_no_records_text' height={'15vh'} emed_tid="other_doc_complaints_left_no_rows">
                                    {t("NoRecordsFound")}
                                </Stack>
                            )
                        }}
                        disableSelectionOnClick
                    />
                </Box>
                {showComplaints && <TextField
                    emed_tid="other_doc_complaints_left_comments_textfield"
                    size='small'
                    multiline={true}
                    rows={5}
                    sx={{ width: '56vw', margin: '1vw' }}
                    label={t("Comments")}
                    value={this.state.commonCommentsTxt}
                    InputProps={{
                        readOnly: true,
                        emed_tid: "other_doc_complaints_left_comments_input"
                    }}
                />}
                {this.state.isErrorMsg ?
                    <ToastMsg
                        emed_tid="other_doc_complaints_left_error_toast"
                        severity={'error'}
                        msg={this.state.isErrorMsgText}
                        msgPop={this.msgClose.bind(this)}
                    />
                    : null}
                {this.state.successMsg ?
                    <ToastMsg
                        emed_tid="other_doc_complaints_left_success_toast"
                        severity={'success'}
                        msg={this.state.successMsgText}
                        msgPop={this.msgClose.bind(this)}
                    />
                    : null}
                {this.state.isDeleteCliked ? <DeletePopup
                    emed_tid="other_doc_complaints_left_delete_popup"
                    DeletTitle={`${t("deleteMsg")} ${t("Complaints")} ${this.state.SelectedList ? this.state.SelectedList?.complaint_description : "-"} ?`}
                    deleteAlertPopupClose={this.popupClose.bind(this)}
                    removeData={this.DeleteComplaintsData.bind(this)}
                /> : null}
            </ShowComponents>
        )
    }
}

export default withTranslation()(OtherDocComplaintsLeft)

